import { render } from "./InserimentoMassivoEe.vue?vue&type=template&id=37689b16&scoped=true"
import script from "./InserimentoMassivoEe.vue?vue&type=script&lang=js"
export * from "./InserimentoMassivoEe.vue?vue&type=script&lang=js"

import "./InserimentoMassivoEe.vue?vue&type=style&index=0&id=37689b16&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37689b16"]])

export default __exports__